<template>
<div>
  <v-dialog persistent v-model="showDialogConfirm" max-width="500px">
    <v-card>
      <v-card-title>
          <v-layout wrap>
              <v-flex xs12 full-height text-center align-center  d-flex fluid >
                <h1 class="m-0">Confirmar</h1><br/>
              </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap text-center>
              <v-flex >
                {{message}}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeDialog">Cancelar</v-btn>
          <v-btn @click="accept" color="success">Aceptar</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
export default {
  props: {
    showDialogConfirm: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog');
    },
    accept(){
      this.$emit('accept');
      this.$emit('close-dialog');
    }
  },
};
</script>
